<template>
    <div class="emk-onboarding center-content">
        <div class="card text-center">
            <div v-if="currentUser && currentUser.email_verified">
                <div v-if="daysLeft > 0">
                    <lottie-vue-player src="https://assets9.lottiefiles.com/packages/lf20_c3t2rekv.json" :player-controls="false" style="width: 200px; height:200px; margin: 0 auto;"></lottie-vue-player>
                    <!-- <lottie-vue-player src="https://assets3.lottiefiles.com/packages/lf20_yek5622k.json" v-if="hasCustomer && firstTeamUsers.length === 1" :player-controls="false" style="width: 200px; height:200px; margin: 0 auto;"></lottie-vue-player> -->
                    <h3 class="h3" v-if="hasUser">Great {{ currentUser.first_name }}! You have unlocked your <strong>{{ daysLeft }} day<span v-if="daysLeft > 1">s</span></strong> trial</h3>
                </div>
                <div v-else>
                    <h3 class="h3" v-if="!hasTenant && hasUser">Hi {{ currentUser.first_name }}! You have no trial days left.</h3>
                </div>
                <h1 class="text-center mb-5"  v-if="daysLeft < 0">Let’s get started!</h1>
                <div class="row">
                    <div class="col-sm-8 offset-2 mt-3">
                        <a href="#" class="btn btn-cta" @click.prevent="$router.push({ name: 'emk-create' })">Configer your <span v-if="emkClusters.length === 0">first</span><span v-else>own</span> EMK cluster</a>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-8 offset-2 mt-5">
                    <h3 class="text-center mb-3">Other actions you can do!</h3>
                    <ul class="steps__category" :class="{'steps__active' : activeSteps.indexOf('extendTrial') > -1}">
                      <div class="is-hidden">
                      <!-- <div> -->
                            <h1>adjustments</h1>
                            <pre>{{ adjustments }}</pre><br>
                            <pre>{{ emailVerifiedCustomer }}</pre>
                            <h1>User</h1>
                            <pre>
                                {{ currentUser }}
                            </pre>
                            <h1>Customer</h1>
                            <pre>
                              {{ currentCustomer }}
                            </pre>
                            <pre>{{ emailVerified }}</pre><br>
                            {{ currentCustomer }}
                            <br>-----><br>
                            <h1>paymentMethods</h1>
                            {{ paymentMethods }}<br>
                            <h1>Team</h1>
                            {{ currentTeam }}
                        </div>
                        <li class="steps__category--header card" :class="{'steps__category--header--cta' : daysLeft <= 0}" @click.prevent="toggleActiveSteps('extendTrial')">
                            <div class="row">
                                <div class="pull-left"><progressCircle v-if="daysAdded" :progress="daysAdded" :maxSteps="14" tooltipText="Trial days" /></div>
                                <p class="pull-left steps__text">Get some extra days! <b-badge variant="primary" class="mr-3">{{ daysAdded }}/14 days</b-badge> <span v-for="(step, index) in trialSteps"><span class="microsteps" :class="{'active': step.value, 'todo': firstFalse.trialSteps.title === step.title }"><span v-if="step.value"><i class="fa fa-check"></i></span><span v-else>{{ index + 1 }}</span></span> <span v-if="firstFalse.trialSteps.title === step.title" class="steps__title">{{ step.title }} </span></span></p>
                                <div class="steps__collapse">
                                    <i class="fa fa-caret-up" aria-hidden="true" v-if="activeSteps.indexOf('extendTrial') > -1"></i>
                                    <i class="fa fa-caret-down" aria-hidden="true" v-else></i>
                                </div>
                            </div>
                        </li>
                        <!-- setStepClass(locked, active, progress, finished) -->
                        <li class="steps card noflex steps--icon" :class="setStepClass(false, !isLoggedIn, false, isLoggedIn)" @click.prevent="registerEmk(!isLoggedIn)">
                            <i class="fa fa-sign-in" aria-hidden="true"></i><i class="fa fa-check" aria-hidden="true"></i>
                            <span>Create your awesome EMK environment</span>
                            <div class="pull-right"><i class="fa fa-ticket" aria-hidden="true"></i> + 3 <span class="visible__hover"> days for your trial</span></div>
                        </li>
                        <li class="steps card noflex steps--icon steps--icon--nolink" v-b-tooltip.hover v-b-tooltip.hover.html="toolTipText('verify')" :class="setStepClass(!isLoggedIn, isLoggedIn && !emailVerifiedCustomer, false, emailVerifiedCustomer)">
                            <i class="fa fa-envelope" aria-hidden="true"></i>
                            <i class="fa fa-check" aria-hidden="true"></i>
                            <i class="fa fa-lock" aria-hidden="true"></i>
                            <span>Verify your email address</span>
                            <div class="pull-right"><i class="fa fa-ticket" aria-hidden="true"></i> + 2 <span class="visible__hover"> days for your trial</span></div>
                        </li>
                        <li class="steps card noflex steps--icon" :class="setStepClass(!isLoggedIn || !currentUser.email_verified, isLoggedIn && currentUser.email_verified && !currentCustomer.address, false, currentCustomer.address)" @click.prevent="addCustomer">
                            <i class="fa fa-address-card-o" aria-hidden="true"></i>
                            <i class="fa fa-check" aria-hidden="true"></i>
                            <i class="fa fa-lock" aria-hidden="true"></i>
                            <span>Add my address</span>
                            <div class="pull-right"><i class="fa fa-ticket" aria-hidden="true"></i> + 2 <span class="visible__hover"> days for your trial</span></div>
                        </li>
                        <li class="steps card noflex steps--icon" v-if="currentCustomer && currentCustomer.address" :class="setStepClass(!currentCustomer.address || !currentUser.email_verified, (currentCustomer.address && !currentUser.phone_number && !receivedStickers), currentUser.phone_number, receivedStickers )" @click.prevent="showPresentForm()">
                            <i class="fa fa-ticket" aria-hidden="true"></i>
                            <i class="fa fa-check" aria-hidden="true"></i>
                            <i class="fa fa-spinner" aria-hidden="true"></i>
                            <i class="fa fa-lock" aria-hidden="true"></i>
                            <span>Receiving stickers</span>
                            <div class="pull-right"><i class="fa fa-gift" aria-hidden="true"></i> <span class="visible__hover"> free gift</span></div>{{ levelOfExpertiseCustomerOwner }}
                        </li>
                        <li class="steps card noflex steps--icon" v-b-tooltip.hover v-b-tooltip.hover.html="toolTipText('level')" :class="setStepClass(isLoggedIn || !currentUser.email_verified || !isCustomerOwner(), isLoggedIn && currentUser.email_verified && !levelOfExpertiseCustomerOwner, false, levelOfExpertiseCustomerOwner )" @click.prevent="addLevel">
                            <i class="fa fa-thermometer-three-quarters" aria-hidden="true"></i>
                            <i class="fa fa-check" aria-hidden="true"></i>
                            <i class="fa fa-lock" aria-hidden="true"></i>
                            <span>My level of expertise</span>
                            <div class="pull-right"><i class="fa fa-ticket" aria-hidden="true"></i> + 1 <span class="visible__hover"> days for your trial</span></div>
                        </li>
                        <li class="steps card noflex steps--icon" v-b-tooltip.hover v-b-tooltip.hover.html="toolTipText('payment')" :class="setStepClass(!currentCustomer || !currentUser.email_verified || !currentCustomer.address, currentCustomer.address && paymentMethods.length === 0, paymentMethods === 'loading', paymentMethods.length > 0 && paymentMethods !== 'loading')" @click.prevent="addPaymentMethod">
                            <i class="fa fa-money" aria-hidden="true"></i>
                            <i class="fa fa-check" aria-hidden="true"></i>
                            <i class="fa fa-spinner" aria-hidden="true"></i>
                            <i class="fa fa-lock" aria-hidden="true"></i> <span>Add a payment method</span>
                            <div class="pull-right"><i class="fa fa-ticket" aria-hidden="true"></i> + 4 <span class="visible__hover"> days for your trial</span></div>
                        </li>
                        <li class="steps card noflex steps--icon" :class="setStepClass(!hasTeams || !currentUser.email_verified, hasTeams && currentUser.email_verified && !extraUsers, false, extraUsers)" @click.prevent="addTeamUser()">
                            <i class="fa fa-users" aria-hidden="true"></i>
                            <i class="fa fa-check" aria-hidden="true"></i>
                            <i class="fa fa-spinner" aria-hidden="true"></i>
                            <i class="fa fa-lock" aria-hidden="true"></i>
                            <span v-if="currentTeamInvites.length > 0 && currentTeam.team_users.length === 1">Invitee need to except your invite</span>
                            <span v-else>Add users to your team</span>
                            <div class="pull-right"><i class="fa fa-ticket" aria-hidden="true"></i> + 2 <span class="visible__hover"> days for your trial</span></div>
                        </li>
                        <li class="steps card noflex steps--icon" v-b-tooltip.hover v-b-tooltip.hover.html="toolTipText" :class="setStepClass(!currentCustomer || !currentCustomer.address || paymentMethods.length === 0, currentCustomer.address && paymentMethods.length > 0, false, false)" @click.prevent="addVoucher()">
                            <i class="fa fa-tag" aria-hidden="true"></i>
                            <i class="fa fa-lock" aria-hidden="true" v-if="paymentMethods !== true"></i> <span>Add voucher code</span>
                            <div class="pull-right"><i class="fa fa-ticket" aria-hidden="true"></i> + ? <span class="visible__hover"> depends on the voucher value</span></div>
                        </li>
                        <li class="steps card noflex steps--icon" :class="{'step__locked': currentCustomer.address, 'step__open': currentCustomer}">
                            <i class="fa fa-lock" aria-hidden="true" v-if="currentCustomer.length == null"></i><i class="fa fa-handshake-o" aria-hidden="true" v-else></i> <span>Contact us with your plan</span>
                            <div class="pull-right"><i class="fa fa-ticket" aria-hidden="true"></i> + ? <span class="visible__hover"> we will give you a suitable amount of days</span></div>
                        </li>
                    </ul>


                    <!-- <ul class="steps__category" :class="{'steps__active' : activeSteps.indexOf('gettingStarted') > -1}">
                        <li class="steps__category--header card" :class="{'steps__category--header--cta' : daysLeft <= 0}" @click.prevent="toggleActiveSteps('gettingStarted')">
                          <div class="row">
                              <div class="pull-left"><progressCircle v-if="daysAdded" :progress="daysAdded" icon="rocket" :maxSteps="9" tooltipText="Trial days" /></div>
                              <p class="pull-left steps__text">Getting started <b-badge variant="primary" class="mr-3">{{ daysAdded }}/5 steps</b-badge> <span v-for="(step, index) in trialSteps"><span class="microsteps" :class="{'active': step.value, 'todo': firstFalse.trialSteps.title === step.title }"><span v-if="step.value"><i class="fa fa-check"></i></span><span v-else>{{ index + 1 }}</span></span> <span v-if="firstFalse.trialSteps.title === step.title" class="steps__title">{{ step.title }} </span></span></p>
                              <div class="steps__collapse">
                                  <i class="fa fa-caret-up" aria-hidden="true" v-if="activeSteps.indexOf('extendTrial') > -1"></i>
                                  <i class="fa fa-caret-down" aria-hidden="true" v-else></i>
                              </div>
                          </div>
                        </li>
                        setStepClass(locked, active, progress, finished)
                        <li class="steps card noflex steps--icon step__finished">
                            <i class="fa fa-envelope" aria-hidden="true"></i><i class="fa fa-check" aria-hidden="true"></i>
                            <span>Create your awesome EMK environment</span>
                            <div class="pull-right"><i class="fa fa-ticket" aria-hidden="true"></i> + 3 <span class="visible__hover"> days for your trial</span></div>
                        </li>
                        <li class="steps card noflex steps--icon steps--icon--nolink" v-b-tooltip.hover v-b-tooltip.hover.html="toolTipText('verify')" :class="setStepClass(false, !emailVerifiedCustomer, false, emailVerifiedCustomer)">
                            <i class="fa fa-envelope" aria-hidden="true"></i><i class="fa fa-check" aria-hidden="true"></i>
                            <span>Verify your email address</span>
                            <div class="pull-right"><i class="fa fa-ticket" aria-hidden="true"></i> + 2 <span class="visible__hover"> days for your trial</span></div>
                        </li>
                    </ul> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getPaymentMethod } from '@/assets/js/api/payment-method';
const svgSpinner = () => import('@/components/svg/svg-spinner');
const svgName = () => import('@/components/svg/svg-name');
import progressCircle from '@/components/svg/progresscircle.vue';
const fIntroEmkClusters = () => import('@/components/emk/f-intro-emk-clusters');

export default {
    data() {
      return {
          activeSteps: ['firstCluster'],
          daysLeft: false,
          hasLevel: false,
          receivedStickers: false,
          paymentMethods: 'loading',
          daysAdded: false,
          extraUsers: false,
          emailVerifiedCustomer: false,
          levelOfExpertiseCustomerOwner: false,
          firstFalse: {
              trialSteps: false,
          },
          trialSteps: [
              {
                title: 'registered',
                value: false,
              },
              {
                title: 'verify',
                value: false,
              },
              {
                title: 'Add address',
                value: false,
              },
              {
                title: 'level of expertise',
                value: false,
              },
              {
                title: 'Add payment method',
                value: false,
              },
              {
                title: 'team',
                value: false,
              },
          ]
      }
    },

    computed: {
        currentUser() {
            return this.$store.state.user.info;
        },

        adjustments() {
            if (this.$store.state.adjustment && this.$store.state.adjustment.list) {
                this.daysLeft = this.$store.state.adjustment.daysLeft;
                this.daysAdded = this.$store.state.adjustment.daysAdded;
                this.trialSteps[0].value = this.$store.state.adjustment.list.find(item => item.name === 'EMK registration - registered') ? true : false;
                this.trialSteps[1].value = this.$store.state.adjustment.list.find(item => item.name === 'EMK registration - verification adjustment') ? true : false;
                this.trialSteps[2].value = this.$store.state.adjustment.list.find(item => item.name === 'EMK registration - customer adjustment') ? true : false;
                this.trialSteps[3].value = this.$store.state.adjustment.list.find(item => item.name === 'EMK registration - knowledge adjustment') ? true : false;
                this.trialSteps[4].value = this.$store.state.adjustment.list.find(item => item.name === 'EMK registration - payment adjustment') ? true : false;
                this.trialSteps[5].value = this.$store.state.adjustment.list.find(item => item.name === 'EMK registration - invitation adjustment') ? true : false;
                this.emailVerifiedCustomer = this.$store.state.adjustment.list.find(item => item.name === 'EMK registration - verification adjustment') ? true : false;
                this.extraUsers = this.$store.state.adjustment.list.find(item => item.name === 'EMK registration - invitation adjustment') ? true : false;
                this.levelOfExpertiseCustomerOwner = this.$store.state.adjustment.list.find(item => item.name === 'EMK registration - knowledge adjustment') ? true : false;
                this.firstFalse.trialSteps = this.trialSteps.find(item => item.value === false) ? this.trialSteps.find(item => item.value === false) : false;
                return this.$store.state.adjustment.list;
            }
        },

        currentCustomer() {
            return this.$store.state.customer.info;
        },

        currentTeam() {
            return this.$store.state.team.current;
        },

        currentTeamInvites() {
            return this.$store.state.team.invitations;
        },

        emkClusters() {
            return this.$store.state.emk.list;
        }
    },

    methods: {
      listPaymentMethods() {
          getPaymentMethod(localStorage.getItem('customer_id'))
          .then((response) => {
              this.paymentMethods = response.data;
          })
          .catch((error) => {
              console.error(error);
              this.showNotification('error', `Fetching your payment methods has failed`);
          });
      },

      toolTipText(element) {
          if (element === 'payment' && !this.currentCustomer.address) {
              return 'First add your address'
          } else if (element === 'verify' && 'EMK registration - verification adjustment') {
              return 'Check your mail inbox and click on the verify link in our message. This way we make sure that you will receive future messages.'
          } else if (element === 'level' && !this.isCustomerOwner()) {
              return 'Only the owner can add these extra days';
          } else if (element !== 'payment' && element !== 'verify' && element !== 'level') {
              if (!this.currentCustomer.address) {
                  return 'First add your address and a payment method'
              } else if (this.currentCustomer.address && this.paymentMethods.length === 0) {
                  return 'First add a payment method for extra verification'
              }
          }
      },

      toggleActiveSteps(value) {
          if (this.activeSteps.indexOf(value) === -1) {
              this.activeSteps.push(value);
          } else {
              this.activeSteps = this.activeSteps.filter(e => e !== value);
          }
      },

      registerEmk(isNotLoggedIn) {
          if (isNotLoggedIn) {
              this.$router.push({ name: 'post-emk' });
          }
      },

      addCustomer() {
          if (this.isLoggedIn && this.currentUser.email_verified && !this.currentCustomer.address && this.activeSteps.indexOf('extendTrial') > -1) {
              this.switchBillingModal('SHOW_FORM_ADDRESS');
          }
      },

      addLevel() {
          if (this.isLoggedIn && this.currentUser.email_verified && this.isCustomerOwner() && !this.levelOfExpertiseCustomerOwner) {
              this.switchBillingModal('SHOW_FORM_LEVEL');
          }
      },

      addPaymentMethod() {
          if (this.isLoggedIn && this.currentUser.email_verified && this.currentCustomer.address && this.paymentMethods.length === 0) {
              this.switchBillingModal('SHOW_ADD_PAYMENT_METHOD');
          }
      },

      showPresentForm() {
          if (this.isLoggedIn && this.currentUser.email_verified && !this.currentUser.phone_number) {this.switchBillingModal('SHOW_FORM_PRESENT')}
      },

      addVoucher() {
          if (this.isLoggedIn && this.currentUser.email_verified && this.currentCustomer.address && this.paymentMethods.length > 0 && this.paymentMethods !== 'loading') {
              this.switchBillingModal('SHOW_ADD_VOUCHER');
          }
      },

      addTeamUser() {
          if (this.isLoggedIn && this.currentUser.email_verified) {
              showTeamModal('SHOW_FORM_INVITE_USER')
          }
      },

      addExtraTeam() {
          if (this.isLoggedIn && this.currentUser.email_verified && this.currentCustomer.address && this.paymentMethods.length > 0 && this.paymentMethods !== 'loading') {
               this.showTeamModal('SHOW_FORM_CREATE_TEAM')
          }
      },

      setStepClass(locked, active, progress, finished) {
          if (finished) {
              return 'step__finished';
          } else if (active) {
              return 'step__active';
          } else if (progress) {
              return 'step__progress';
          } else if (locked) {
              return 'step__locked';
          }
      },
    },

    mounted() {
        if (localStorage.getItem('customer_id') != null) {
            if (!this.paymentMethods) {
                this.listPaymentMethods();
            }
        } else {
            this.paymentMethods = false;
        }
        if (this.hasTeams) {
            this.fetchTeamInvitations();
        }
        if (this.isLoggedIn) {
            this.fetchAdjustments();
        }

        if (!this.isLogged || (this.currentUser && !this.currentUser.email_verified)) {
            this.activeSteps = ['extendTrial'];
        }
    },

    components: {
        svgSpinner,
        svgName,
        progressCircle,
        fIntroEmkClusters,
    },
}
</script>
<style scoped="scoped">
.steps__category {
    list-style: none;
    padding: 0;
    cursor: pointer;
    position: relative;
    margin-bottom: 100px;
}
.steps__category > li {
  padding: 10px;
}
.steps {
  top: 0;
  width: 100%;
  left: 0;
  transition: all 0.5s ease-in-out;
}
.steps {
    /* margin-top: -62px; */
    margin-bottom: -49px;
    margin-top: -10px;
    transition: all 0.5s ease-in-out;
    color: #fff;
    min-height: 42px;
    text-align: left;
    /* transform: rotate(.2deg); */
}
.steps__active .steps > .steps {
    width: calc(100% - 20px);
    margin: -10px;
    padding-top: 10px;
}

.steps__active .steps > .steps.steps--icon > span {
    margin-left: 50px;
}
.steps__category:not(.steps__active):hover .steps {
    margin-top: -2px;
}
.steps > .fa {
    border-right: 1px solid #dde4e7;
    height: 40px;
    display: inline-block;
    position: absolute;
    top: 0;
    left: 0;
    line-height: 40px;
    padding: 0 10px;
    width: 40px;
    text-align: center;
}
.steps--icon > span {
  margin-left: 40px;
}
.steps .pull-right {
    opacity: 0;
    transition: all 0.1s ease-in-out;
}
/* .steps__category:hover .steps, */
.steps__active .steps {
    margin-top: 0;
    margin-bottom: 0;
    color: inherit;
}
.steps__active .steps .pull-right {
  float: right;
  opacity: 1;
  transition: all .8s ease-in-out;
}
.steps__category--header {
  font-weight: 800;
  z-index: 2;
  margin-bottom: 0;
}
.steps__category--header .row {
  margin: 0;
}
.steps__category--header.steps__category--header--cta {
    padding: 10px 25px;
}
/* .steps__category:hover .steps:hover, */
.steps__active .steps:hover {
    background: #24CEBD;
    color: #fff;
}
.steps__active .steps > .steps:hover {
    background: transparent;
}
/* .steps__category:hover .steps:hover .visible__hover, */
.steps__active .steps:hover .visible__hover {
    display: inline-block;
}
.visible__hover,
.steps__active .steps.step__locked:hover .visible__hover,
.steps__active .steps.step__finished:hover .visible__hover  {
    display: none;
}
.steps__active .step__locked,
.steps__active .step__locked:hover,
.steps__active .step__finished,
.steps__active .step__progress,
.steps__active .step__finished:hover,
.steps__active .step__progress:hover {
    opacity: .5;
    background: #fff !important;
    cursor: default;
    color: inherit !important;
}
/* .step__finished .fa, */
/* .step__progress .fa, */
/* .steps__active .step__finished .pull-right, */
.steps__active .step__progress .pull-right {
    display: none;
}
.steps > .fa {
    display: none;
}
.step__active > .fa:first-child {
    display: inline-block;
}
.steps.step__finished .fa-check {
    display: inline-block;
}
.step__finished > span {
    text-decoration: line-through;
}
.step__progress .fa-spinner {
    display: inline-block;
}
.step__locked .fa-lock {
    display: inline-block;
}
.step__open .fa {
    display: inline-block;
}
.steps--icon--nolink {
    cursor: default;
}
.microsteps {
    background: #dae1e7;
    border-radius: 50%;
    height: 15px;
    width: 15px;
    text-align: center;
    display: inline-block;
    color: #fff;
    margin-left: 2px;
    font-size: 10px;
}
.microsteps.active {
  background: #24CEBD;
}
.microsteps.todo {
  background: #242f4b;
}
.steps__text {
    margin: 18px 0 0 10px;
}
.steps__collapse {
    margin: auto 10px auto auto;
}
.btn-cta {
  margin: 0 auto;
}
.steps__title {
  margin: 5px 0 0 0;
}
</style>
